// Papéis administrativos da api (`Role#slug`). Gestores continuam acessando a
// área do aluno durante a janela para conseguir validar a plataforma fechada.
const BYPASS_ROLE_SLUGS = ['admin', 'sebrae_admin']

type SessionLike = {
  user?: {
    roles?: Array<{ slug?: string } | null> | null
  } | null
} | null

export function hasMaintenanceBypass(session: SessionLike): boolean {
  const roles = session?.user?.roles

  if (!Array.isArray(roles)) return false

  return roles.some(role => Boolean(role?.slug) && BYPASS_ROLE_SLUGS.includes(role!.slug!))
}
